<template>
  <div style="background: linear-gradient(to bottom, #eee, #eee)">
    <div class="h5bg" v-if="entInfo" style="border:0;height:70px;background:none">
      <div style="position:absolute;width:57px;height:54px; bottom:-5px; left:50px;z-index:1">
        <img :src="'./img/jiazi.png'" />
      </div>

      <div style="position:absolute;width:57px;height:54px; bottom:-5px; right:50px;z-index:1">
        <img :src="'./img/jiazi.png'" />
      </div>


    </div>
    <div class="h5bg" v-if="entInfo">


      <div class="title">{{ entInfo.firm_name }}招聘启事</div>
      <div class="desc">
        <!-- <div>{{ entInfo.firm_name }}</div> -->
        <div class="flexCenter">统一社会信用代码：{{ entInfo.firm_num }}</div>
        <div>单位简介：</div>
        <div style="word-break: break-all;">{{ entInfo.enter_desc }}</div>
        <div>招聘信息：</div>
        <div v-for="(job,i) in entInfo.jobList" :key="i">
          <div style="border-top:1px solid #eee;">
            【职位名称】{{job.job_name}}
          </div>
          <div>
            【招聘人数】{{job.need_num}}
          </div>
          <div v-if="pmid!=220">
            【职位要求】学历：{{job.eduaction}}；英语：{{job.english_level}}；工作经验：{{job.experience}}；计算机：{{job.computer_level}}
          </div>
          <div v-if="pmid == 220">
            【职位要求】学历：{{ job.eduaction }}
          </div>
          <div>
            【职位描述】{{job.job_desc}}
          </div>
          <div v-if="pmid != 220">
            【工作地址】{{job.word_addr}}
          </div>
          <div v-if="pmid == 220">
            【工作城市】{{ job.cityName || CITY_DIC[job.city] || '-' }}
          </div>
        </div>

        <div>联系方式</div>

        <div>联系人：{{ entInfo.firm_principal }}</div>
        <div>联系电话：{{ entInfo.tel }}</div>
        <div>E-mail：{{ entInfo.email }}</div>
        <div>通讯地址：{{ entInfo.address }}</div>

      </div>

    </div>
    <div style="height:100px"></div>
  </div>
</template>

<script>
import citys from "../../utils/arae_value.js";
import util from "@/utils/util";
export default {
  data() {
    return {
      id: 0,
      entInfo: null,
      qyxz: [],
      xzfw: [],
      xlyq: [],
      gzjy: [],
      wyyq: [],
      jsjyq: [],
      gwshzz: [],
      pmid:window.pmid
    };
  },
  mounted() {
    let cityList = this.TreeToArrayFor(citys)
    let CITY_DIC = {}
    for (let i = 0, len = cityList.length; i < len; i++) {

      CITY_DIC[cityList[i].value] = cityList[i].label

    }
    this.CITY_DIC = CITY_DIC

    this.id = this.$route.params.id;
    this.getComType()
    
    document.title="招聘启事"
    this.getConfig()
  },
  methods: {
    /**
    * tree转数组，循环模式，每次增加循环的变量
    * 【注意：】只能使用for 循环，不能使用es6的迭代器
    * @param tree
    * @returns {{length}|*}
    * @constructor
    */
    TreeToArrayFor(tree) {
      if (!Array.isArray(tree) || !tree.length) throw new Error("请传入数组")
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children) {
          // 每次children有值，就把值合并到原始数据tree上去，增加原始tree，for 循环 的长度也会增加 依次处理...
          tree = tree.concat(tree[i].children)
        }
      }
      return tree
    },
    getConfig(){
      this.$http.post("/api/sch_configs").then(res => {
        let config = {}
        for (let k of res.data) {
          config[k.ktype] = k.kvalue
        }

        if (config.favico) {
          var link = document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = config.favico;
          document.getElementsByTagName('head')[0].appendChild(link);
        }

      });
    },
    getComType() {
      return new Promise(resolve => {
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'ENTER_INFO','SALARY_RANGE','EDUACTION','EXPERIENCE','ENGLISH_LEVEL','COMPUTER_LEVEL','GWSHZT'",
            used: 0
          })
          .then(res => {
            let qyxz = []; //企业性质
            let xzfw = []; //薪资类型
            let xlyq = []; //学历类型
            let gzjy = []; //工作经验
            let wyyq = []; //外语要求
            let jsjyq = []; //计算机要求
            let gwshzz = []; //计算机要求
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == "SALARY_RANGE") {
                if (item.param_value == 0) item.param_desc = '面议'
                xzfw.push(item);
              }
              if (item.param_type == "EDUACTION") {
                xlyq.push(item);
              }
              if (item.param_type == "EXPERIENCE") {
                gzjy.push(item);
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq.push(item);
              }
              if (item.param_type == "COMPUTER_LEVEL") {
                jsjyq.push(item);
              }
              if (item.param_type == "GWSHZT") {
                gwshzz.push(item);
              }
            }
            this.qyxz = qyxz;
            this.xzfw = xzfw;
            this.xlyq = xlyq;
            this.gzjy = gzjy;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            this.gwshzz = gwshzz;
            this.getData();
            resolve();
          });
      });
    },
    getData() {
      this.$http.post("/api/h5_enter_info", { id: this.id, check_status: 1 }).then((res) => {
        for(let job of res.data.jobList){
          for(let e of this.gzjy){
            if(e.param_value==job.experience){
              job.experience = e.param_desc
              break
            }
          }
          for(let e of this.xlyq){
            if(e.param_value==job.eduaction){
              job.eduaction = e.param_desc
              break
            }
          }
          for(let e of this.wyyq){
            if(e.param_value==job.english_level){
              job.english_level = e.param_desc
              break
            }
          }
          for(let e of this.jsjyq){
            if(e.param_value==job.computer_level){
              job.computer_level = e.param_desc
              break
            }
          }
          if (job.city){

      
            let areaNames = util.getParentAreaByValue(citys, job.city)
          if (areaNames && areaNames.length > 0) {
            job.cityName = areaNames.map(a => a.label).reverse().join('/');
            }
          }
        }
        this.entInfo = res.data;
      });
    },
  },
};
</script>

<style scoped>
.h5bg {
  max-width: 1000px;
  border:10px solid #fff;
  margin: 0 auto;
background:#fff;
  position:relative;
  padding:20px;
  color:#373d5e;
}
.title {
  font-size: 40px;
  text-align: center;
  color: blue;
  padding-top:50px;
  text-stroke: 2px white;  
  -webkit-text-stroke: 1px white;  
}
.desc {
  line-height: 50px;
}
</style>
